export default __webpack_public_path__ + "static/media/pobal-logo-gray-400.461f6ba0.svg";